export const CREATE_ORDER = 'CREATE_ORDER'
export const GET_LIST_ORDER = 'GET_LIST_ORDER'
export const DETAIL_ORDER = 'DETAIL_ORDER'
export const PATCH_ORDER = 'PATCH_ORDER'
